export enum Role {
  Admin = "Admin",
  SuperAdmin = "Super Admin",
  Specialist = "Coach",
}

export type JwtPayload = {
  sub: string;
};

export type Credentials = {
  email?: string;
  password?: string;
  username?: string;
};

export type UserResponse = {
  user?: User;
}

export type User = {
  id?: string;
  avatar: string;
  name: string;
  email: string;
  address: string;
  occupation: string;
  role: Role;
  active: number;
  createdAt: string;
  updatedAt: string;
  image?: string;
  phone?: string;
  state?: string;
};

export type Profile = {
  id: string;
  name: string;
  email: string;
  accessToken: string;
  refreshToken: string;
  access_token?: string;
};
